/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the VwStoricoAnnoDto interface.
 */
export function instanceOfVwStoricoAnnoDto(value) {
    return true;
}
export function VwStoricoAnnoDtoFromJSON(json) {
    return VwStoricoAnnoDtoFromJSONTyped(json, false);
}
export function VwStoricoAnnoDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'pkStorico': json['pkStorico'] == null ? undefined : json['pkStorico'],
        'fkProgetto': json['fkProgetto'] == null ? undefined : json['fkProgetto'],
        'fkProgettoIntranet': json['fkProgettoIntranet'] == null ? undefined : json['fkProgettoIntranet'],
        'denominazioneProgetto': json['denominazioneProgetto'] == null ? undefined : json['denominazioneProgetto'],
        'dataSnapshot': json['dataSnapshot'] == null ? undefined : (new Date(json['dataSnapshot'])),
        'fkChiaveMisura': json['fkChiaveMisura'] == null ? undefined : json['fkChiaveMisura'],
        'denominazioneMisura': json['denominazioneMisura'] == null ? undefined : json['denominazioneMisura'],
        'stValore': json['stValore'] == null ? undefined : json['stValore'],
        'stDeltaValorePrecedente': json['stDeltaValorePrecedente'] == null ? undefined : json['stDeltaValorePrecedente'],
        'stValorePrecedente': json['stValorePrecedente'] == null ? undefined : json['stValorePrecedente'],
    };
}
export function VwStoricoAnnoDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'pkStorico': value['pkStorico'],
        'fkProgetto': value['fkProgetto'],
        'fkProgettoIntranet': value['fkProgettoIntranet'],
        'denominazioneProgetto': value['denominazioneProgetto'],
        'dataSnapshot': value['dataSnapshot'] == null ? undefined : ((value['dataSnapshot']).toISOString().substring(0, 10)),
        'fkChiaveMisura': value['fkChiaveMisura'],
        'denominazioneMisura': value['denominazioneMisura'],
        'stValore': value['stValore'],
        'stDeltaValorePrecedente': value['stDeltaValorePrecedente'],
        'stValorePrecedente': value['stValorePrecedente'],
    };
}
